import { Injectable } from '@angular/core';
import {
  AUTO_PROMPTS,
  AutoPrompt,
  ChatMessage,
} from '../../components/ai-agent-tool/ai-agent-tool.data';
import { BehaviorSubject, lastValueFrom, map, take } from 'rxjs';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';
import { SettingInfo } from '../../class/state-manager';

@Injectable({
  providedIn: 'root',
})
export class ChatControllerService {
  public messageBox: ChatMessage[] = [];
  public messageBox$: BehaviorSubject<ChatMessage[]> = new BehaviorSubject<ChatMessage[]>(
    this.messageBox,
  );

  public autoPrompts: AutoPrompt[] = AUTO_PROMPTS['first'];
  public autoPrompts$: BehaviorSubject<AutoPrompt[]> = new BehaviorSubject<AutoPrompt[]>(
    this.autoPrompts,
  );

  constructor(private threeGraphqlService: ThreeGraphqlService) {}

  public addMessage(message: ChatMessage): void {
    console.log('addMessage', message);
    this.messageBox.push(message);
    this.messageBox$.next(this.messageBox);
  }

  public sendMessage(
    message: string,
    projectUuid: string,
    setting?: Array<SettingInfo>,
  ): Promise<ChatMessage> {
    const messageData: ChatMessage = {
      type: 'user',
      message,
      partModelUuids: [],
      setting: [],
    };
    this.messageBox.push(messageData);
    this.messageBox$.next(this.messageBox);
    return this.sendAiChat(message, projectUuid, setting);
  }

  public resetChatbot(projectUuid: string): Promise<any> {
    console.log('asfasfasfasfs');
    return lastValueFrom(
      this.threeGraphqlService.resetChatbot(projectUuid).pipe(
        map((response) => {
          this.messageBox = [];
          this.messageBox$.next(this.messageBox);
          return response;
        }),
      ),
    );
  }

  public setAutoPrompts(type: string): void {
    this.autoPrompts = AUTO_PROMPTS[type];
    this.autoPrompts$.next(this.autoPrompts);
  }

  private sendAiChat(
    message: string,
    projectUuid: string,
    setting?: Array<SettingInfo>,
  ): Promise<ChatMessage> {
    console.log(setting);
    return lastValueFrom(
      this.threeGraphqlService.sendAiChat(message, projectUuid, setting).pipe(
        take(1),
        map((response) => {
          const messageData: ChatMessage = {
            type: 'ai',
            message: response.message,
            partModelUuids: response.partModelUuids,
            setting: response.setting ? JSON.parse(response.setting) : response.setting,
          };
          this.messageBox.push(messageData);
          this.messageBox$.next(this.messageBox);
          return messageData;
        }),
      ),
    );
  }
}
